import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'reco.consentToolCard.title',
    defaultMessage: 'Erhalte bessere Empfehlungen',
  },
  description: {
    id: 'reco.consentToolCard.description',
    defaultMessage:
      'Aktiviere Personalisierungs- Cookies & Dienste, damit wir dir Inhalte zeigen können, die besser zu deinen Interessen passen.',
  },
  buttonTitle: {
    id: 'reco.consentToolCard.button.title',
    defaultMessage: 'Personalisierung aktivieren',
  },
});
